<div class="container">
  <p>{{display}}</p>
  <p class="subtitle" *ngIf="ingredient.numberOfSteps > 1">Split between {{ingredient.numberOfSteps}} steps</p>
</div>
